import { render, staticRenderFns } from "./xiude.vue?vue&type=template&id=107af0d4&scoped=true&"
import script from "./xiude.vue?vue&type=script&lang=js&"
export * from "./xiude.vue?vue&type=script&lang=js&"
import style0 from "./xiude.vue?vue&type=style&index=0&id=107af0d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107af0d4",
  null
  
)

export default component.exports